<div class="container-fluid">
  <div class="header">
    <h2>Mensagens Automáticas</h2>
  </div>

  <div class="cards-container">
    <!-- Card 1: Mensagem Cadastro na plataforma -->
    <div class="message-card">
      <div class="card-header">
        <h5>Mensagem Cadastro na plataforma</h5>
      </div>
      <div class="card-body">
        <form [formGroup]="formCadastro" (ngSubmit)="salvarFormCadastro()">
          <div class="form-group">
            <textarea 
              formControlName="conteudo" 
              class="form-control" 
              rows="6" 
              placeholder="Digite a mensagem de cadastro na plataforma...">
            </textarea>
            <small class="text-danger" *ngIf="isFieldInvalidForm(formCadastro, 'conteudo')">
              {{ getFieldErrorForm(formCadastro, 'conteudo') }}
            </small>
          </div>
          <div class="form-actions">
            <button type="submit" class="btn btn-primary">Salvar</button>
          </div>
        </form>
      </div>
    </div>

    <!-- Card 2: Mensagem solicitação de serviço sem agendamento -->
    <div class="message-card">
      <div class="card-header">
        <h5>Mensagem solicitação de serviço sem agendamento</h5>
      </div>
      <div class="card-body">
        <form [formGroup]="formSolicitacaoSemAgendamento" (ngSubmit)="salvarFormSolicitacaoSemAgendamento()">
          <div class="form-group">
            <textarea 
              formControlName="conteudo" 
              class="form-control" 
              rows="6" 
              placeholder="Digite a mensagem de solicitação de serviço sem agendamento...">
            </textarea>
            <small class="text-danger" *ngIf="isFieldInvalidForm(formSolicitacaoSemAgendamento, 'conteudo')">
              {{ getFieldErrorForm(formSolicitacaoSemAgendamento, 'conteudo') }}
            </small>
          </div>
          <div class="form-actions">
            <button type="submit" class="btn btn-primary">Salvar</button>
          </div>
        </form>
      </div>
    </div>

    <!-- Card 3: Mensagem solicitação de serviço com agendamento -->
    <div class="message-card">
      <div class="card-header">
        <h5>Mensagem solicitação de serviço com agendamento</h5>
      </div>
      <div class="card-body">
        <form [formGroup]="formSolicitacaoComAgendamento" (ngSubmit)="salvarFormSolicitacaoComAgendamento()">
          <div class="form-group">
            <textarea 
              formControlName="conteudo" 
              class="form-control" 
              rows="6" 
              placeholder="Digite a mensagem de solicitação de serviço com agendamento...">
            </textarea>
            <small class="text-danger" *ngIf="isFieldInvalidForm(formSolicitacaoComAgendamento, 'conteudo')">
              {{ getFieldErrorForm(formSolicitacaoComAgendamento, 'conteudo') }}
            </small>
          </div>
          <div class="form-actions">
            <button type="submit" class="btn btn-primary">Salvar</button>
          </div>
        </form>
      </div>
    </div>

    <!-- Card 4: Mensagem confirmação de atendimento -->
    <div class="message-card">
      <div class="card-header">
        <h5>Mensagem confirmação de atendimento</h5>
      </div>
      <div class="card-body">
        <form [formGroup]="formConfirmacaoAtendimento" (ngSubmit)="salvarFormConfirmacaoAtendimento()">
          <div class="form-group">
            <textarea 
              formControlName="conteudo" 
              class="form-control" 
              rows="6" 
              placeholder="Digite a mensagem de confirmação de atendimento...">
            </textarea>
            <small class="text-danger" *ngIf="isFieldInvalidForm(formConfirmacaoAtendimento, 'conteudo')">
              {{ getFieldErrorForm(formConfirmacaoAtendimento, 'conteudo') }}
            </small>
          </div>
          <div class="form-actions">
            <button type="submit" class="btn btn-primary">Salvar</button>
          </div>
        </form>
      </div>
    </div>

    <!-- Card 5: Mensagem confirmação 24hs antes do atendimento -->
    <div class="message-card">
      <div class="card-header">
        <h5>Mensagem confirmação 24hs antes do atendimento</h5>
      </div>
      <div class="card-body">
        <form [formGroup]="formConfirmacao24h" (ngSubmit)="salvarFormConfirmacao24h()">
          <div class="form-group">
            <textarea 
              formControlName="conteudo" 
              class="form-control" 
              rows="6" 
              placeholder="Digite a mensagem de confirmação 24hs antes do atendimento...">
            </textarea>
            <small class="text-danger" *ngIf="isFieldInvalidForm(formConfirmacao24h, 'conteudo')">
              {{ getFieldErrorForm(formConfirmacao24h, 'conteudo') }}
            </small>
          </div>
          <div class="form-actions">
            <button type="submit" class="btn btn-primary">Salvar</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div> 